import React from "react";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import { Input, Button, Paper, Grid, Typography } from "material-ui";
import { withStyles } from "material-ui/styles";
import { fade } from "material-ui/styles/colorManipulator";
import classnames from "classnames";
import Survey, { STATUS as SURVEY_STATUS } from "models/Survey";
import { isAdmin, isCustomerAdmin } from "utils/formatter";
import BackButton from "components/BackButton";
import AttrImg from "assets/images/attr.png";
import AttrDImg from "assets/images/disabled-attr.png";
import BaseImg from "assets/images/base.png";
import BaseDImg from "assets/images/disabled-base.png";
import AdditionImg from "assets/images/additions.png";
import AdditionDImg from "assets/images/disabled-additions.png";
import PreviewImg from "assets/images/preview.png";
import PreviewDImg from "assets/images/disabled-preview.png";
import MonitorImg from "assets/images/monitor.png";
import MonitorDImg from "assets/images/disabled-monitor.png";
import ReportImg from "assets/images/report.png";
import ReportDImg from "assets/images/disabled-report.png";
import ErrorMessage from "components/ErrorMessage";
import Dialog, {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "material-ui/Dialog";
import Loader from 'react-loader-spinner';
import axios from "axios";
import "moment/locale/ja";
import moment from "moment";
import DatePicker from "uis/CustomDatePicker";
import { pathRole } from "../../utils/formatter";
import storage from "../../utils/storage";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0
  },
  main: {
    padding: 20
  },
  errorMessages: {
    margin: "10px 20px 0",
    marginLeft: "75px",
    marginRight: "20px",
    "& ul": {
      border: "0px",
    }
  },
  errorMessagesMailSend: {
    margin: "14px 20px 0",
    marginLeft: "2px",
    marginRight: "2px",
    "& ul": {
      border: "0px",
    }
  },
  exportCSV: {
    float: "right",
    marginTop: 6
  },
  customerInfo: {
    borderBottom: "1px solid lightgray",
    paddingBottom: 10
  },
  paperRow: {
    padding: "10px 15px"
  },
  surveyUrlPaperRow: {
    padding: "15px 15px 0"
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1rem",
    fontWeight: 300
  },
  paperValue: {
    color: "#575962",
    marginTop: "0.1rem",
    marginLeft: "1.5rem",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600
  },
  paperPeriod: {
    color: "#575962",
    marginTop: "0.1rem",
    margin: "0 1rem",
    display: "inline-block",
    fontSize: "0.9rem",
    fontWeight: 600
  },
  paperHeader: {
    padding: "1rem 1.8rem",
    color: "#575962",
    fontSize: "1.1rem",
    fontWeight: 600,
    borderBottom: "3px solid #ebedf2"
  },
  paperHeader2: {
    padding: "1rem 1.8rem",
    color: "#575962",
    textAlign: "center",
    fontSize: "1rem",
    fontWeight: 100,
    borderBottom: "2px solid #ebedf2"
  },
  paperContent: {
    padding: "2rem 1.8rem 1rem"
  },
  centerPaperContent: {
    padding: "2rem 1.8rem 1rem",
    textAlign: "center"
  },
  paperCard: {
    height: 200,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: fade("#2196F3", 0.1),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  },
  paperDisabled: {
    height: 200,
    backgroundColor: "rgba(0, 0, 0, 0.12)"
  },
  paperIcon: {
    fontSize: 80,
    color: "#073150"
  },
  statusLabel: {
    borderRadius: 15,
    color: "white",
    padding: "2px 15px",
    fontWeight: "normal"
  },
  statusBtn: {
    marginRight: 10
  },
  statusActions: {
    marginLeft: 40,
    display: "inline-block"
  },
  basicInfoLabel: {
    float: "left",
    marginTop: 7
  },
  editBtn: {
    float: "right"
  },
  basicInfoPaperWrapper: {
    marginBottom: 0,
    paddingBottom: 0
  },
  basicInfoPaper: {
    marginBottom: 20,
    position: "relative",
    height: 330
  },
  surveyLocale: {
    height: 290,
    overflowY: "scroll"
  },
  btnNavActionRoot: {
    maxWidth: "none"
  },
  soloLocale: {
    pointerEvents: "none"
  },
  selectedNavItem: {
    color: "#fff",
    backgroundColor: "#26a69a"
  },
  employeesInfo: {
    borderBottom: "1px solid lightgray"
  },
  termInfo: {
    borderBottom: "1px solid lightgray"
  },
  copyBtn: {},
  adminPaperContent: {
    marginBottom: 20
  },
  imageSize: {
    height: 80,
    width: 80
  },
  clear: {
    clear: "both"
  },
  confirmMessage: {
    fontSize: '1.6rem',
    color: 'red',
    marginTop: '1rem'
  },
  confirmButton: {
    background: '#26a69a'
  },
  confirmDialogText: {
    marginLeft: "50px",
    width: "600px",
    float: "left"
  }
});

const StatusConfirmBtn = props => (
  <Button
    dense
    raised
    disabled={props.surveyDetail.surveyLocales.length === 0}
    className={props.classes.statusBtn}
    onClick={props.updateStateTo(SURVEY_STATUS.CONFIRM, props)}
  >
    確定する
  </Button>
);
const StatusReadyBtn = props => (
  <Button
    dense
    raised
    className={props.classes.statusBtn}
    onClick={props.updateStateTo(SURVEY_STATUS.READY, props)}
  >
    確定解除
  </Button>
);
const StatusOpenBtn = props => (
  <Button
    dense
    raised
    disabled={props.surveyDetail.surveyLocales.length === 0}
    className={props.classes.statusBtn}
    onClick={props.updateStateTo(SURVEY_STATUS.OPEN, props)}
  >
    公開する
  </Button>
);
const StatusStopBtn = props => (
  <Button
    dense
    raised
    className={props.classes.statusBtn}
    onClick={props.updateStateTo(SURVEY_STATUS.STOP, props)}
  >
    中断する
  </Button>
);
const StatusFinishBtn = props => (
  <Button
    dense
    raised
    className={props.classes.statusBtn}
    onClick={props.updateStateTo(SURVEY_STATUS.FINISH, props)}
  >
    終了する
  </Button>
);

const StatusRestartBtn = props => (
  <Button
    dense
    raised
    className={props.classes.statusBtn}
    onClick={props.updateStateTo(SURVEY_STATUS.OPEN, props)}
  >
    再開する
  </Button>
);

const StatusActions = props => {
  switch (props.status) {
    case SURVEY_STATUS.READY:
      return (
        <div>
          <StatusConfirmBtn {...props} btn="確定する" />
        </div>
      );
    case SURVEY_STATUS.CONFIRM:
      return (
        <div>
          <StatusOpenBtn {...props} btn="公開する" />
          <StatusReadyBtn {...props} btn="確定解除" />
        </div>
      );
    case SURVEY_STATUS.OPEN:
      return (
        <div>
          <StatusStopBtn {...props} btn="中断する" />
          <StatusFinishBtn {...props} btn="終了する" />
        </div>
      );
    case SURVEY_STATUS.STOP:
      return (
        <div>
          <StatusRestartBtn {...props} btn="再開する" />
          <StatusFinishBtn {...props} btn="終了する" />
        </div>
      );
    case SURVEY_STATUS.FINISH:
    case 0:
      return null;
    default:
      throw new Error("no case");
  }
};

const Panel = props => {
  const { classes, onClick, label, image, disabled } = props;

  return (
    <Paper
      className={disabled ? classes.paperDisabled : classes.paperCard}
      onClick={onClick}
    >
      <div className={classes.paperHeader2}>{label}</div>
      <div className={classes.centerPaperContent}>
        <img src={image} alt="" className={classes.imageSize} />
      </div>
    </Paper>
  );
};

class SurveyDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      fileName: '',
      invalidFile: false,
      invalidFileSize: false,
      errorMessage: [],
      showReqPreview: false,
      showImport: false,
      showConfirmReport: false,
      setDateStep: false,
      importedData: [[], [], []],
      isLoading: false,
      endDate: moment(new Date()).format('YYYY/MM/DD HH:mm'),
      showUploadResult: false,
      uploadStatus: {
        isSuccess: true,
        messages: "",
      },
      mailSendType: "-",
      mailSendTypeNumber: 0,
      isSendConfirmModalOpen: false,
      isMailSendSuccess: false,
      isCsvExportClicked: false,
      isSendErrorModalOpen: false,
      fileInputRef: ''
    };
  }
  componentWillMount() {
    this.props.fetchSurveyDetail();
    window.scroll(0, 0);
  }
  componentWillUnmount() {
    this.props.init();
  }


  render() {
    const { classes, surveyDetail, createSurvey} = this.props;
    const {
      customer,
      survey,
      surveyLocales,
      selectedSurveyLocale,
      errors
    } = surveyDetail;

    const {
      employeeCount,
      urlNullCount
    } = this.props.employeeCount;

    const {
      showEmployeeImport,
      showUploadResult,
      uploadStatus = { isSuccess: true, messages: "" },
      isLoading,
      fileName,
      invalidFile,
      invalidFileSize,
      isSendConfirmModalOpen,
      isMailSendSuccess,
      isCsvExportClicked,
      isSendErrorModalOpen,
      mailSendTypeNumber

    } = this.state;

    const { getCSV } = this.props;
    const { getSurveyAttributes } = this.props;

    const resultBgColor = uploadStatus.isSuccess ? "#dff0d8" : "#ffebee";
    const resultBorderColor = uploadStatus.isSuccess ? "#3c763d" : "#d53333";
    const resultTextColor = uploadStatus.isSuccess ? "#3c763d" : "#d53333";


    const baseApiUrl = () => {
      const isDevelop = process.env.NODE_ENV === "development";

      return isDevelop ? `http://${window.location.hostname}:3001/api` : "/api";
    };

    const base = baseApiUrl();
    const role = pathRole();

    const handleDateChange = date => {
      this.setState({
        endDate: date
      });
    };
    const handleClose = () => {
      if (this.state.showReqPreview && this.state.isCsvExportClicked) {
        this.props.fetchSurveyDetail();
      }
      this.setState({
        showReqPreview: false,
        isCsvExportClicked: false
      });
    };

    const handleClickOpen = () => {
      this.setState({
        showReqPreview: true
      });
    };

    const openImportModal = () => {
      this.setState({
        isLoading: false,
        showImport: true,
        errorMessage: []
      });
    };

    const closeImportModal = () => {
      if (!this.state.isLoading) {
        this.setState({
          file: null,
          fileName: '',
          showImport: false,
          invalidFile: false,
          errorMessage: []
        });
      }
    };

    const closeSetDateModal = () => {
      this.setState({
        isLoading: false,
        setDateStep: false
      });
    };


    const rollbackToSetDate = () => {
      this.setState({
        isLoading: true
      });
      const data = {
        token: storage.getToken(),
        survey_id: survey.id,
        survey_status: survey.status
      };

      axios({
        method: 'delete',
        url: `${base}/${role}/dlt_survey_report/${survey.id}`,
        data
      }).then(() => {
        setTimeout(() => {
          this.setState({
            isLoading: false,
            setDateStep: true,
            showConfirmReport: false
          });
        }, 500);
      });
    };
    const closeConfirmReport = () => {
      this.setState({
        showConfirmReport: false,
      });
      window.location.reload();
    };

    const getFile = (event) => {
      if (event.target.files[0]) {
        if (event.target.files[0].size > 2 * 1024 * 1024) {
          this.setState({
            errorMessage: ["ファイルサイズが2 MBを超えている"],
            fileName: event.target.files[0].name,
            invalidFileSize: true
          });
        } else {
          this.setState({
            invalidFileSize: false,
            errorMessage: [],
            file: event.target.files[0],
            fileName: event.target.files[0].name
          });
        }
      }
    };
    const getFileEmployeeMaster = (event) => {
      const selectedFile = event.target.files && event.target.files[0];

      if (!selectedFile) return;

      if (selectedFile.size > 2 * 1024 * 1024) {
        this.setState({
          errorMessage: ["ファイルサイズが2 MBを超えている"],
          fileName: '',
          invalidFileSize: true,
          file: null
        });
        return;
      }
      this.setState({
        invalidFileSize: false,
        errorMessage: [],
        file: selectedFile,
        fileName: selectedFile.name
      });
    };
    const finishSurvey = () => {
      this.setState({
        isLoading: true
      });
      const params = {
        token: storage.getToken(),
        is_import: true,
        survey: {
          status: 5,
          lockVersion: survey.lockVersion
        },
        end_date: this.state.endDate
      };
      axios({
        method: 'patch',
        url: `${base}/${role}/survey_detail/${survey.id}`,
        data: params
      }).then(() => {
        const data = {
          token: storage.getToken(),
          date: moment(this.state.endDate).format('YYYY-MM-DD HH:mm:ss'),
          survey_id: survey.id
        };
        axios({
          method: 'patch',
          url: `${base}/${role}/import_csv_date/${survey.id}`,
          data
        });
        this.setState({
          isLoading: false
        });
        setTimeout(() => {
          this.setState({
            setDateStep: false,
            showConfirmReport: true
          });
        }, 500
        );
      });
    };

    const rollBack = () => {
      this.setState({
        isLoading: true
      });
      const data = {
        token: storage.getToken(),
        survey_result_id: this.state.importedData[0],
        addition_result_id: this.state.importedData[1],
        attribute_results_id: this.state.importedData[2]
      };
      axios({
        method: 'delete',
        url: `${base}/${role}/delete_imported_csv/${survey.id}`,
        data
      }).then(() => {
        const params = {
          token: storage.getToken(),
          date: moment(survey.endDt).format('YYYY-MM-DD HH:mm:ss'),
          op_finish_date: moment(survey.operateFinishDt).format('YYYY-MM-DD HH:mm:ss'),
          survey_id: survey.id
        };
        axios({
          method: 'patch',
          url: `${base}/${role}/import_csv_date/${survey.id}`,
          data: params
        });
        setTimeout(() => {
          this.setState({
            isLoading: false,
            setDateStep: false,
            showImport: true,
            errorMessage: []
          });
        }, 500
        );
      });
    };

    const openReportDetail = () => {
      window.open(window.location.href.replace(`survey_detail/${survey.id}`, `report_detail/${survey.id}`));
    };

    const openBasicReport = () => {
      window.open(window.location.href.replace(`survey_detail/${survey.id}`, `basic_report/${survey.id}`));
    };

    const openOriginalReport = () => {
      window.open(window.location.href.replace(`survey_detail/${survey.id}`, `original_report/${survey.id}`));
    };

    const openResultIndexReport = () => {
      window.open(window.location.href.replace(`survey_detail/${survey.id}`, `result_index_report/${survey.id}`));
    };

    const openCommentResult = () => {
      window.open(window.location.href.replace(`survey_detail/${survey.id}`, `free_opinion_1_report/${survey.id}`));
    };

    const openComment2Result = () => {
      window.open(window.location.href.replace(`survey_detail/${survey.id}`, `free_opinion_2_report/${survey.id}`));
    };

    const uploadFile = () => {
      const attrs = [];
      this.setState({
        errorMessage: []
      });
      if (surveyDetail.attrs) {
        surveyDetail.attrs.forEach(item => {
          const attrItems = [];
          attrItems.push(item.id);
          attrs.push(attrItems);
        });
      }
      if (this.state.file && this.state.file.name.split('.').pop() === "csv") {
        this.setState({
          invalidFile: false,
          isLoading: true
        });
        const formData = new FormData();
        formData.append('file', this.state.file);
        formData.append('token', storage.getToken());
        formData.append('survey_id', survey.id);
        formData.append('start_date', new Date());
        formData.append('end_date', new Date());
        formData.append('locale_id', surveyLocales[0].localeId);
        axios({
          method: 'post',
          url: `${base}/${role}/survey_detail/${survey.id}/import_csv`,
          data: formData
        }).then(res => {
          if (res.data.message === "Successfully imported") {
            this.setState({
              showImport: false,
              importedData: res.data.data,
              isLoading: false
            });
            setTimeout(() => {
              this.setState({
                setDateStep: true
              });
            }, 500
            );
          } else {
            const { message } = res.data;
            this.setState({
              isLoading: false,
              errorMessage: message,
              file: null,
              fileName: '',
            });
            if (this.fileInputRef) {
              this.fileInputRef.value = '';
            }
          }
        }).catch(error => {
          if (!error.response) {
            this.setState({
              isLoading: false,
              file: null,
              fileName: '',
              errorMessage: ["ファイルの内容が変更されています。お手数ですが、再度ファイルを選択してインポートしてください。"],
            });
            if (this.fileInputRef) {
              this.fileInputRef.value = '';
            }
          }
        });
      } else {
        this.setState({
          invalidFile: true,
          file: null,
          fileName: '',
        });
      }
      if (this.fileInputRef) {
        this.fileInputRef.value = '';
      }
    };


    const openEmployeeImportModal = () => {
      this.setState({
        isLoading: false,
        showEmployeeImport: true,
        errorMessage: []
      });
    };

    const closeEmployeeImportModal = () => {
      if (!this.state.isLoading) {
        this.setState({
          file: null,
          fileName: '',
          showEmployeeImport: false,
          invalidFile: false,
          errorMessage: []
        });
      }
    };

    const startNewImport = () => {
      this.setState({
        showUploadResult: false,
        showEmployeeImport: true,
        file: null,
        fileName: "",
        invalidFile: false,
        invalidFileSize: false,
        errorMessage: []
      });
    };

    const goToMainPage = () => {
      this.setState({
        showUploadResult: false,
        file: null,
        fileName: "",
      });
    };

    const closeErrorDialogAfterMailSend = () => {
      this.setState({
        isSendErrorModalOpen: false,
      });
    };

    const handleSendClick = (type) => {
      const mailSendTypeOption = Survey.getMailSendTypeByValue(type);
      if (mailSendTypeOption && type === mailSendTypeOption.value) {
        this.setState({
          isSendConfirmModalOpen: true,
          mailSendTypeNumber: mailSendTypeOption.number,
        });
      } else {
        this.setState({
          isSendErrorModalOpen: true,
          errorMessage: ["配信方式は「発行/一斉送信」か「リマインド送信」を選択してください。"]
        });
      }
    };

    const uploadEmployeeCsvFile = () => {
      const {file} = this.state;

      if (file && (file.type === 'text/csv' || file.name.endsWith('.csv'))) {
        this.setState({isLoading: true, errorMessage: []});

        const formData = new FormData();
        formData.append('file', file);
        formData.append('survey_id', survey.id);
        formData.append('token', storage.getToken());

        axios.post(`${base}${isAdmin() ? '/admin/import' : '/customer_admin/import'}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            this.setState({
              isLoading: false,
              showEmployeeImport: false,
              showUploadResult: false,
              isCsvExportClicked: true,
              showReqPreview: true,
              fileName: '',
              uploadStatus: {
                isSuccess: true,
                messages: `${response.data.message}`,
              },
            });

            // window.location.reload()
          })
          .catch(error => {
            if (!error.response) {
              this.setState({
                isLoading: false,
                file: null,
                fileName: '',
                errorMessage: ["ファイルの内容が変更されています。お手数ですが、再度ファイルを選択してインポートしてください。"],
              });
              if (this.fileInputRef) {
                this.fileInputRef.value = '';
              }
              return;
            }
            const errorMessages = (error.response && error.response.data && error.response.data.errors) || ['ファイルのアップロード中に予期せぬエラーが発生しました。'];

            this.setState({
              isLoading: false,
              showEmployeeImport: true,
              showUploadResult: false,
              errorMessage: errorMessages,
              file: null,
              fileName: '',
              invalidFile: false,
            });

            if (this.fileInputRef) {
              this.fileInputRef.value = '';
            }
          });
      } else {
        this.setState({
          errorMessage: ["ファイルの形式が不正です。CSVファイルを使用してください。"],
          isLoading: false,
          file: null,
          fileName: '',
          // showImport: false
        });
        if (this.fileInputRef) {
          this.fileInputRef.value = '';
        }
      }
    };

    const exportEmployeeCsv = () => {
      this.setState({isLoading: true});

      axios
        .get(`${base}/admin/export_employee_csv?token=${storage.getToken()}&survey_id=${survey.id}`, {
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], {type: "text/csv;charset=utf-8;"});
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const now = new Date();
          const dateString = now.getFullYear() +
            String(now.getMonth() + 1).padStart(2, '0') +
            String(now.getDate()).padStart(2, '0');
          link.setAttribute("download", `niser-es_${survey.customerId}_Profiles_${dateString}`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.setState({
              isLoading: false,
              showUploadResult: false,
              showReqPreview: true,
              isCsvExportClicked: true,
              uploadStatus: {
                isSuccess: true,
                messages: "登録されている回答者情報がありません。",
              },
            });
          } else {
            const errorMessage = (error.response && error.response.data && error.response.data.errors) || "CSVエクスポート中にエラーが発生しました。";
            this.setState({
              isLoading: false,
              showUploadResult: true,
              uploadStatus: {
                isSuccess: true,
                messages: errorMessage,
              },
            });
          }
        });
    };


    const handleSendTypeChange = (event) => {
      const selectedType = event.target.value;
      this.setState({ mailSendType: selectedType });
    };


    const handleCloseSendConfirmModal = () => {
      this.setState({
        isSendConfirmModalOpen: false,
        isMailSendSuccess: false,
        isLoading: false
      });
    };

    const handleConfirmSend = async () => {
      const formData = new FormData();
      formData.append('token', storage.getToken());
      formData.append('survey_id', survey.id);
      formData.append('survey_name', surveyLocales[0].surveyName);
      formData.append('survey_end_dt', survey.endDt);
      formData.append('mail_send_Type', mailSendTypeNumber);
      this.setState({ isLoading: true });

      axios.post(`${base}${isAdmin() ? '/admin/send_mail_to_individual' : '/customer_admin/send_mail_to_individual'}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        this.setState({
          showEmployeeImport: false,
          showUploadResult: false,
          isMailSendSuccess: true,
          isSendConfirmModalOpen: true,
          isLoading: false,
          uploadStatus: {
            isSuccess: true,
            messages: response.data.message,
          },
          mailSendType: '-',
        });
        this.props.fetchSurveyDetail();
      }).catch(error => {
        this.setState({
          showEmployeeImport: false,
          showUploadResult: false,
          isMailSendSuccess: false,
          isSendConfirmModalOpen: false,
          isSendErrorModalOpen: true,
          isLoading: false,
          showImport: false,
          mailSendType: '-',
          errorMessage: error.response.data.errors
        });
      });
    };


    const { errorMessage } = this.state;
    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>アンケート詳細</h2>
          <BackButton />
        </div>
        <ErrorMessage messages={errors} className={classes.errorMessages} />
        <Dialog
          fullWidth
          maxWidth="md"
          open={showEmployeeImport}
          onClose={closeEmployeeImportModal}
        >
          <DialogTitle>ファイル選択</DialogTitle>
          <Typography component="div" variant="body2">
            <ErrorMessage messages={errorMessage} className={classes.errorMessages} />
            <DialogContent>
              <div
                style={{
                  display: invalidFile ? "block" : "none",
                  backgroundColor: "#ffebee",
                  border: "1px solid #d53333",
                  borderRadius: "5px"
                }}
              >
                <h4
                  style={{
                    marginLeft: "20px",
                    padding: "10px 10px",
                    color: "#d53333"
                  }}
                >
                  ファイルの形式が不正です。CSVファイルを使用してください。
                </h4>
              </div>
              {isLoading && (
                <div style={{textAlign: "center"}}>
                  <Loader
                    type="RevolvingDot"
                    color="#575962"
                    height="50"
                    width="50"
                  />
                </div>
              )}
              <Input
                disabled
                disableUnderline
                value={fileName}
                style={{
                  margin: "40px 0px 40px 40px",
                  width: "700px"
                }}
              />
              <Button
                dense
                raised
                disabled={isLoading}
                style={{
                  marginBottom: "0px",
                  marginLeft: "10px",
                  width: "100px",
                  height: "31px"
                }}
                component="label"
              >
                選択
                <input
                  type="file"
                  onChange={getFileEmployeeMaster}
                  ref={( ref) => (this.fileInputRef = ref)}
                  style={{display: "none", margin: "0"}}
                />
              </Button>
            </DialogContent>
          </Typography>
          <DialogActions>
            <Button
              raised
              disabled={isLoading}
              style={{
                color: "#fff",
                marginRight: "30px"
              }}
              onClick={closeEmployeeImportModal}
            >
              キャンセル
            </Button>
            <Button
              raised
              disabled={isLoading || invalidFileSize}
              style={{
                backgroundColor: "#26a69a",
                marginLeft: "30px"
              }}
              onClick={uploadEmployeeCsvFile}
            >
              インポート
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth="md"
          open={showUploadResult}
          onClose={goToMainPage}
        >
          <DialogTitle>
            {uploadStatus.isSuccess ? "処理完了" : "処理失敗"}
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                backgroundColor: resultBgColor,
                border: `1px solid ${resultBorderColor}`,
                borderRadius: "5px",
                color: resultTextColor,
                padding: "10px 20px",
                marginBottom: "20px"
              }}
            >
              <DialogContentText
                style={{
                  color: resultTextColor,
                  margin: 0,
                  fontSize: '1rem'
                }}
              >
                {uploadStatus.messages}
              </DialogContentText>
            </div>
          </DialogContent>
          <DialogActions>
            {!uploadStatus.isSuccess && (
              <Button
                raised
                onClick={startNewImport}
                style={{
                  color: "#fff",
                  backgroundColor: "#707070",
                  marginRight: "10px"
                }}
              >
                キャンセル (インポート画面へ)
              </Button>
            )}
            <Button
              raised
              onClick={goToMainPage}
              style={{
                backgroundColor: "#4A3E92"
              }}
            >
              閉じる
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth="md"
          open={isSendErrorModalOpen}
          onClose={closeErrorDialogAfterMailSend}
        >
          <div style={{
            marginTop: "40px",
            marginLeft: "150px",
            fontSize: "1.25rem"
          }}
          >
            <span>
              {errorMessage}
            </span>
          </div>
          <DialogActions>
            <Button
              raised
              onClick={closeErrorDialogAfterMailSend}
              style={{
                backgroundColor: "#4A3E92",
                marginTop: "30px",
                marginBottom: "10px",
                fontSize: "1.25rem"
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth='md'
          open={this.state.showImport}
          onClose={closeImportModal}
        >
          <DialogTitle>ファイル選択</DialogTitle>
          <Typography component="div" variant="body2">
            <DialogContent>
              <div
                style={{
                  display: this.state.invalidFile ? "block" : "none",
                  backgroundColor: "#ffebee",
                  border: "1px solid #d53333",
                  borderRadius: "5px",
                }}
              >
                <h4
                  style={{
                    marginLeft: "20px",
                    padding: "10px 10px",
                    color: "#d53333"
                  }}
                > ファイルの形式が不正です。CSVファイルを使用してください。
                </h4>
              </div>
              { this.state.isLoading && (
                <div style={{ textAlign: "center" }}>
                  <Loader
                    type="RevolvingDot"
                    color="#575962"
                    height="50"
                    width="50"
                  />
                </div>
                )
              }
              <div style={{ display: errorMessage.length > 0 ? "block" : "none" }}>
                <div
                  style={{
                    backgroundColor: "#ffebee",
                    border: "1px solid #d53333",
                    borderRadius: "5px",
                    color: "#d53333"
                  }}
                >
                  {
                    errorMessage.map((value, keyIndex) => {
                    if (keyIndex <= 9) {
                      return (
                        <h4
                          style={{
                            marginLeft: "20px",
                            padding: "0px 10px"
                          }}
                        > {value}
                        </h4>
                      );
                    }
                    return ('');
                    })
                  }
                </div>
              </div>
              <Input
                disabled
                disableUnderline
                value={this.state.fileName}
                style={{
                margin: "40px 0px 40px 40px",
                width: "700px",
              }}
              />
              <Button
                dense
                raised
                disabled={this.state.isLoading}
                style={{
                  marginBottom: "0px",
                  marginLeft: "10px",
                  width: "100px",
                  height: "31px"
                }}
                component="label"
              >
                選択
                <input
                  type="file"
                  onChange={(evt) => getFile(evt)}
                  ref={( ref) => (this.fileInputRef = ref)}
                  style={{ display: "none", margin: "0" }}
                />
              </Button>
            </DialogContent>
          </Typography>
          <DialogActions>
            <Button
              raised
              disabled={this.state.isLoading}
              style={{
                color: "#fff",
                marginRight: "30px"
              }}
              onClick={closeImportModal}
            >
              キャンセル
            </Button>
            <Button
              raised
              disabled={this.state.isLoading || this.state.invalidFileSize}
              style={{
                backgroundColor: "#26a69a",
                marginLeft: "30px"
              }}
              onClick={uploadFile}
            >
              インポート
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth
          disableBackdropClick
          maxWidth='md'
          open={this.state.setDateStep}
          onClose={closeSetDateModal}
        >
          <DialogTitle>終了日時の選択</DialogTitle>
          <DialogContent>
            { this.state.isLoading && (
              <div style={{ textAlign: "center" }}>
                <Loader
                  type="RevolvingDot"
                  color="#575962"
                  height="50"
                  width="50"
                />
              </div>
            )
            }
            <div
              style={{
                display: "block",
                backgroundColor: "#009689",
                color: "white"
              }}
            >
              <h4
                style={{
                  marginLeft: "20px",
                  padding: "10px 10px"
                }}
              > インポートが完了しました。アンケートの終了日時を選択してください。
              </h4>
            </div>
            <div style={{ height: "300px", display: "block" }}>
              <div style={{ display: "inline" }}>
                <Input
                  value={moment(this.state.endDate).format('YYYY-MM-DD HH:mm')}
                  disabled
                  disableUnderline
                  style={{
                    margin: "10px 20px 0px 125px",
                    width: "500px",
                    float: "left"
                  }}
                />
                <DatePicker
                  style={{
                    marginTop: "50px",
                    float: "left"
                  }}
                  selectedDate={this.state.endDate}
                  onChange={date => handleDateChange(date)}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              raised
              disabled={this.state.isLoading}
              style={{
                color: "#fff",
                backgroundColor: "#707070",
                marginRight: "70px"
              }}
              onClick={rollBack}
            >
              キャンセル
            </Button>
            <Button
              raised
              disabled={this.state.isLoading}
              style={{ backgroundColor: "#26a69a" }}
              onClick={finishSurvey}
            >
              確定する
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          fullWidth
          disableBackdropClick
          maxWidth='md'
          open={this.state.showConfirmReport}
          onClose={closeConfirmReport}
        >
          <DialogTitle>レポート確認</DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "block",
                backgroundColor: "#37b61c",
                color: "white",
              }}
            >
              <h4
                style={{
                  marginLeft: "20px",
                  padding: "10px 10px"
                }}
              > インポートが完了しました。レポートはこのように作成されます。
              </h4>
            </div>
            { this.state.isLoading && (
              <div style={{ textAlign: "center" }}>
                <Loader
                  type="RevolvingDot"
                  color="#575962"
                  height="50"
                  width="50"
                />
              </div>
              )
            }
            <div style={{ display: "inline-block" }}>
              <h3 className={classes.confirmDialogText}>NiserES調査結果レポート</h3>
              <Button
                raised
                disabled={this.state.isLoading}
                onClick={openReportDetail}
                className={classes.confirmButton}
              >
                確認する
              </Button>
            </div>
            <div style={{ display: "inline-block" }}>
              <h3 className={classes.confirmDialogText}>1. 属性別集計結果 Q1~Q63</h3>
              <Button
                raised
                disabled={this.state.isLoading}
                onClick={openBasicReport}
                className={classes.confirmButton}
              >
                確認する
              </Button>
            </div>
            <div style={{ display: "inline-block" }}>
              <h3 className={classes.confirmDialogText}>2. 属性別集計結果 Q64~Q83</h3>
              <Button
                raised
                onClick={openOriginalReport}
                disabled={this.state.importedData[1].length === 0 || this.state.isLoading}
                className={classes.confirmButton}
              >
                確認する
              </Button>
            </div>
            <div style={{ display: "inline-block" }}>
              <h3 className={classes.confirmDialogText}>3. 質問別集計結果指数</h3>
              <Button
                raised
                disabled={this.state.isLoading}
                onClick={openResultIndexReport}
                className={classes.confirmButton}
              >
                確認する
              </Button>
            </div>
            <div style={{ display: "inline-block" }}>
              <h3 className={classes.confirmDialogText}>自由記入１</h3>
              <Button
                raised
                disabled={this.state.isLoading}
                onClick={openCommentResult}
                className={classes.confirmButton}
              >
                確認する
              </Button>
            </div>
            <div style={{ display: "inline-block" }}>
              <h3 className={classes.confirmDialogText}>自由記入２</h3>
              <Button
                raised
                disabled={!this.state.importedData[3] || this.state.isLoading}
                onClick={openComment2Result}
                className={classes.confirmButton}
              >
                確認する
              </Button>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              raised
              disabled={this.state.isLoading}
              style={{
                marginRight: "70px"
              }}
              onClick={rollbackToSetDate}
            >
              インポートし直す
            </Button>
            <Button
              raised
              disabled={this.state.isLoading}
              style={{
                marginLeft: "70px"
              }}
              onClick={closeConfirmReport}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.showReqPreview}
          onClose={handleClose}
        >
          <DialogContent>
            {!isCsvExportClicked ? ((survey.isMailSendToEmployee && survey.checkFlg === 0 && employeeCount < 1) ? (
                <div>
                  <DialogContentText>
                    アンケートの内容が変更されています。 チェック/プレビュー画面を最後までご確認頂かないと先へは進めません。
                  </DialogContentText>
                </div>
              ) : !survey.isMailSendToEmployee && survey.checkFlg === 0 ? (
                <DialogContentText style={{marginBottom: "70px", textAlign: "center"}}>
                  アンケートの内容が変更されています。 チェック/プレビュー画面を最後までご確認頂かないと先へは進めません。
                </DialogContentText>
              ) : (survey.isMailSendToEmployee && survey.checkFlg === 1 && employeeCount < 1) ? (
                <DialogContentText style={{textAlign: "center", width: "950px"}}>
                  回答者情報が登録されておりません。
                </DialogContentText>
              ) : <DialogContentText>
                アンケートの内容が変更されています。 チェック/プレビュー画面を最後までご確認頂かないと先へは進めません。
              </DialogContentText>
            ) : (
              this.state.showReqPreview && uploadStatus.isSuccess && (
                <DialogContentText style={{textAlign: "center", width: "950px"}}>
                  {uploadStatus.messages}
                </DialogContentText>
              ))}
          </DialogContent>
          <DialogActions>
            <Button dense raised onClick={handleClose}> OK </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth='md'
          open={isSendConfirmModalOpen}
          onClose={handleCloseSendConfirmModal}
          min
        >

          <span style={{textAlign: 'center', fontSize: '1.25rem', marginTop: "70px"}}>{isMailSendSuccess ? uploadStatus.messages : Survey.getMailSendTypeByValue('reminder').value === this.state.mailSendType ? "未回答の方へリマインド送信をします。よろしいでしょうか？" : "アンケート実施URLを一斉送信します。よろしいでしょうか ?"}</span>

          {isLoading && (
            <div style={{ textAlign: "center", marginTop: "40px" }}>
              <Loader
                type="RevolvingDot"
                color="#575962"
                height="50"
                width="50"
              />
            </div>)}

          <DialogActions style={{justifyContent: 'center', padding: '10px 0 30px'}}>
            {isMailSendSuccess ?
              (
                <Button
                  raised
                  style={{
                    backgroundColor: '#004c8c',
                    color: '#fff',
                    width: '150px',
                    height: '55px',
                    fontWeight: 'bold',
                    fontSize: '1.25rem',
                    borderRadius: '2px',
                    marginTop: "68px"
                  }}
                  onClick={handleCloseSendConfirmModal}
                >
                  閉じる
                </Button>
              ) :
              (<div
                style={{
                  display: 'flex',
                  gap: '200px',
                  padding: '10px',
                  marginTop: '100px'
                }}
              >
                <Button
                  raised
                  disabled={isLoading}
                  style={{
                    backgroundColor: '#004c8c',
                    color: '#fff',
                    width: '150px',
                    height: '55px',
                    fontWeight: 'bold',
                    fontSize: '1.25rem',
                    borderRadius: '2px',
                  }}
                  onClick={handleCloseSendConfirmModal}
                >
                  キャンセル
                </Button>
                <Button
                  raised
                  disabled={isLoading}
                  style={{
                    backgroundColor: '#509f98',
                    color: '#fff',
                    width: '150px',
                    height: '55px',
                    fontWeight: 'bold',
                    fontSize: '1.25rem',
                    borderRadius: '2px',
                  }}
                  onClick={handleConfirmSend}
                >
                  はい
                </Button>
              </div>)}
          </DialogActions>
        </Dialog>

        <div className={classes.main}>
          <div className={classes.customerInfo}>
            <Grid container spacing={24}>
              <Grid item xs={12} md={6}>
                <div className={classes.paperDesc}>会社名</div>
                <div className={classes.paperValue}>
                  {`${customer.customerName} ( ID: ${customer.customerKey})`}
                </div>
              </Grid>

              <Grid item xs={12} md={6}>
                <div className={classes.paperDesc}>状態</div>
                <div>
                  <div className={classes.paperValue}>
                    <div
                      className={classes.statusLabel}
                      style={survey.backgroundColor()}
                    >
                      {survey.statusFmt()}
                    </div>
                  </div>

                  <div className={classes.statusActions}>
                    {isAdmin() && (
                      <StatusActions
                        status={survey.status}
                        classes={classes}
                        surveyDetail={surveyDetail}
                        updateStateTo={(status, props) => {
                          if (surveyDetail.survey.checkFlg === 0) {
                            return handleClickOpen;
                          }
                          if (props.btn !== '確定解除' && survey.isMailSendToEmployee &&
                            survey.status === SURVEY_STATUS.CONFIRM && employeeCount < 1) {
                            return handleClickOpen;
                          } else {
                            return this.props.updateStatusTo(
                              status,
                              survey,
                              createSurvey
                            );
                          }
                        }
                      }
                      />
                    )}
                    {isCustomerAdmin() &&
                      survey.status === SURVEY_STATUS.READY && (
                        <StatusConfirmBtn
                          status={survey.status}
                          classes={classes}
                          surveyDetail={surveyDetail}
                          updateStateTo={status => {
                            if (surveyDetail.survey.checkFlg === 0) {
                              return handleClickOpen;
                            }
                            if (survey.isMailSendToEmployee &&
                              survey.status === SURVEY_STATUS.CONFIRM && employeeCount < 1) {
                              return handleClickOpen;
                            } else {
                              return this.props.updateStatusTo(
                                status,
                                survey,
                                createSurvey
                              );
                            }
                          }
                        }
                        />
                      )}
                  </div>
                  <div style={{ float: "right" }}>
                    {isAdmin() && (
                      <Button
                        dense
                        raised
                        className={classes.exportCSV}
                        onClick={openImportModal}
                        disabled={
                          survey.isReady() ||
                          survey.isConfirm() ||
                          survey.status === 0
                        }
                      >
                        結果入力(CSV)
                      </Button>
                    )}


                    <div>
                      {isAdmin() && (
                        <Button
                          dense
                          raised
                          className={classes.exportCSV}
                          onClick={getCSV(survey.id)}
                          disabled={
                            surveyDetail.loading ||
                            survey.isReady() ||
                            survey.isConfirm() ||
                            survey.status === 0
                          }
                        >
                          結果出力(CSV)
                        </Button>
                      )}
                    </div>

                    <div>
                      {isAdmin() && (
                        <Button
                          dense
                          raised
                          className={classes.exportCSV}
                          onClick={getSurveyAttributes(survey.id)}
                          disabled={
                            surveyDetail.attrLoading ||
                            survey.isReady() ||
                            survey.isConfirm() ||
                            survey.status === 0
                          }
                        >
                          属性一覧(CSV)
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>

          <div className={classes.paperHeader}>
            <div className={classes.basicInfoLabel}>基本情報</div>
            <Button
              raised
              disabled={!survey.canUseBaseInfo(isAdmin())}
              className={classes.editBtn}
              onClick={this.props.handleEdit}
            >
              編集
            </Button>
            <div className={classes.clear} />
          </div>

          <div
            className={classnames(
              classes.paperContent,
              classes.basicInfoPaperWrapper
            )}
          >
            <Grid container spacing={24}>
              <Grid item xs={12} md={6}>
                <Paper className={classes.basicInfoPaper}>
                  <div className={classes.surveyLocale}>
                    <div className={classes.paperRow}>
                      <div className={classes.paperDesc}>アンケート名</div>
                      <div className={classes.paperPeriod}>
                        {selectedSurveyLocale.surveyName || "未設定"}
                      </div>
                    </div>
                    <div className={classes.paperRow}>
                      <div className={classes.paperDesc}>アンケート説明</div>
                      <div className={classes.paperPeriod}>
                        {selectedSurveyLocale.description || "未設定"}
                      </div>
                    </div>
                  </div>

                  <BottomNavigation
                    value={selectedSurveyLocale.localeId}
                    onChange={this.props.changeLocale}
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      left: 0
                    }}
                    showLabels
                  >
                    {surveyLocales.map(sl => (
                      <BottomNavigationAction
                        key={sl.id}
                        value={sl.locale.id}
                        label={sl.locale.jaLabel}
                        classes={{
                          root: classes.btnNavActionRoot
                        }}
                        className={classnames(
                          surveyLocales.length === 1 ? classes.soloLocale : "",
                          selectedSurveyLocale.localeId === sl.locale.id
                            ? classes.selectedNavItem
                            : ""
                        )}
                      />
                    ))}
                  </BottomNavigation>
                </Paper>
              </Grid>

              <Grid item xs={12} md={6}>
                <Paper className={classes.basicInfoPaper}>
                  <div className={classes.employeesInfo}>
                    <div className={classes.paperRow}>
                      <div style={{ display: "inline-block", width: "50%" }}>
                        <div className={classes.paperDesc}>対象者数</div>
                        <div
                          className={classes.paperPeriod}
                          style={{
                            textAlign: "right",
                            width: "70%"
                          }}
                        >
                          {survey.employees} 名
                        </div>
                      </div>
                      <div style={{ display: "inline-block", width: "50%" }}>
                        <div className={classes.paperDesc}>追加設問数</div>
                        <div
                          className={classes.paperPeriod}
                          style={{
                            textAlign: "right",
                            width: "70%"
                          }}
                        >
                          {survey.additionLimit} 問
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={classes.termInfo}>
                    <div className={classes.paperRow}>
                      <div className={classes.paperDesc}>公開期間</div>
                      <div className={classes.paperPeriod}>
                        {survey.termFmt()}
                      </div>
                    </div>
                  </div>

                  <div className={classes.surveyLoninInfo}>
                    {(isAdmin() && survey.isMailSendToEmployee
                      && survey.status < SURVEY_STATUS.OPEN) ? (
                        <div>
                          <div  style={{ paddingLeft: "15px", paddingTop: "10px" }} className={classes.paperDesc}>回答者情報</div>
                          <div style={{display: "flex",  margin: "40px"}}>
                            <Paper
                              style={{
                                padding: "20px",
                                textAlign: "center",
                                cursor: "pointer",
                                minWidth: "40px",
                                margin: "auto",
                                backgroundColor: "#4A3E92",
                                color: "white",
                                transition: "all 0.3s ease",
                                width: "100px",
                              }}
                              onClick={openEmployeeImportModal}
                            >
                              <div style={{fontWeight: "bold", fontSize: "0.9rem"}}>
                                回答者登録 <br/>(CSV)
                              </div>
                            </Paper>

                            <Paper
                              style={{
                                padding: "20px",
                                textAlign: "center",
                                cursor: "pointer",
                                minWidth: "40px",
                                backgroundColor: "#4A3E92",
                                color: "white",
                                marginRight: "28px",
                                transition: "all 0.3s ease",
                              }}
                              onClick={exportEmployeeCsv}
                            >
                              <div style={{fontWeight: "bold", fontSize: "0.9rem"}}>
                                回答者情報出力 <br/> (CSV)
                              </div>
                            </Paper>
                          </div>
                        </div>
                      ) :
                      (survey.status === SURVEY_STATUS.OPEN && survey.isMailSendToEmployee) ? (
                        <div>
                          <div className={classes.paperRow}>
                            <div className={classes.paperDesc}>回答者特定方式</div>
                          </div>
                          <div
                            className={classes.paperRow}
                            style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "16px"
                          }}
                          >
                            <div
                              className={classes.paperDesc}
                              style={{
                                flexShrink: 0
                            }}
                            >
                              アンケート実施URL
                            </div>
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexGrow: 1,
                              justifyContent: "flex-end"
                            }}
                            >
                              <div style={{
                                position: "relative",
                                display: "inline-block",
                              }}
                              >
                                <select
                                  value={this.state.mailSendType}
                                  onChange={handleSendTypeChange}
                                  style={{
                                    padding: "6px 10px",
                                    paddingRight: "40px", // space for the arrow
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    fontSize: "0.9rem",
                                    minWidth: "150px",
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    backgroundColor: "#fff",
                                    cursor: "pointer",
                                  }}
                                >
                                  {Survey.mailSendTypeOptions(urlNullCount).map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                      disabled={urlNullCount === 0 && option.value === "broadcast"}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>

                                <div style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                  bottom: 0,
                                  width: "30px",
                                  backgroundColor: "#4A3E92",
                                  borderRadius: "0 4px 4px 0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  pointerEvents: "none",
                                }}
                                >
                                  <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2 4L5 7L8 4"
                                      stroke="white"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                              <Button
                                dense
                                raised
                                className={classes.copyBtn}
                                onClick={() => handleSendClick(this.state.mailSendType)}
                                style={{
                                  flexShrink: 0
                                }}
                              >
                                送信
                              </Button>
                            </div>
                          </div>

                          <div
                            className={classes.paperRow}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "200px"
                            }}
                          >
                            <div className={classes.paperDesc} style={{flexShrink: 0}}>パスワード</div>
                            <div style={{display: "flex", alignItems: "center", gap: "8px", flexGrow: 1}}>
                              <div style={{flexGrow: 1, padding: '6px 10px', fontFamily: 'monospace'}}>
                              <span
                                ref={(el) => {
                                  this.surveyPassword = el;
                                }}
                              >
                                {survey.surveyPassword || "XXXXXXXXXX"}
                              </span>
                              </div>
                              <Button
                                dense
                                raised
                                className={classes.copyBtn}
                                onClick={() =>
                                  this.props.copyToClipboard(this.surveyPassword.innerHTML)
                                }
                                style={{flexShrink: 0}}
                              >
                                コピー
                              </Button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className={classes.paperRow} style={{alignItems: "center", gap: "16px"}}>
                            <div className={classes.paperDesc} style={{flexShrink: 0}}>
                              アンケート実施URL
                            </div>
                            <div className={classes.paperPeriod} style={{ width: "78%" }}>
                              <span
                                ref={(el) => {
                                  this.surveyUrl = el;
                                }}
                              >
                                {!(!isAdmin() && survey.isMailSendToEmployee) && survey.status === SURVEY_STATUS.OPEN ? survey.answerLoginUrl() : "準備中"}
                              </span>
                            </div>
                            <div style={{float: "right"}}>
                              {survey.status === SURVEY_STATUS.OPEN &&
                                !(survey.isMailSendToEmployee && isCustomerAdmin()) && (
                                  <Button
                                    dense
                                    raised
                                    className={classes.copyBtn}
                                    onClick={() =>
                                      this.props.copyToClipboard(
                                        this.surveyUrl.innerHTML
                                      )
                                    }
                                  >
                                    コピー
                                  </Button>
                                )}
                            </div>
                          </div>

                          <div className={classes.paperRow} style={{alignItems: "center", gap: "80px"}}>
                            <div className={classes.paperDesc} style={{flexShrink: 0}}>パスワード</div>
                            <div className={classes.paperPeriod} style={{width: "78%"}}>
                              <span
                                ref={(el) => {
                                  this.surveyPassword = el;
                                }}
                              >
                                {!(!isAdmin() && survey.isMailSendToEmployee) && survey.status === SURVEY_STATUS.OPEN ? survey.surveyPassword : "準備中"}
                              </span>
                            </div>
                            <div style={{float: "right"}}>
                              {survey.status === SURVEY_STATUS.OPEN &&
                                !(survey.isMailSendToEmployee && isCustomerAdmin()) && (
                                  <Button
                                    dense
                                    raised
                                    className={classes.copyBtn}
                                    onClick={() =>
                                      this.props.copyToClipboard(this.surveyPassword.innerHTML)
                                    }
                                    style={{flexShrink: 0}}
                                  >
                                    コピー
                                  </Button>
                                )}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </Paper>
              </Grid>
            </Grid>
          </div>

          <div className={classes.paperHeader}>設問設定</div>
          <div className={classes.paperContent}>
            <Grid container spacing={24}>
              <Grid item xs={12} md={4}>
                <Panel
                  disabled={
                    surveyLocales.length === 0 || !survey.canUseAttr(isAdmin())
                  }
                  classes={classes}
                  onClick={
                    surveyLocales.length > 0 && survey.canUseAttr(isAdmin())
                      ? this.props.clickAttrSelectCard
                      : undefined
                  }
                  label="属性選択"
                  image={
                    surveyLocales.length > 0 && survey.canUseAttr(isAdmin())
                      ? AttrImg
                      : AttrDImg
                  }
                />
              </Grid>

              {isAdmin() && (
                <Grid item xs={12} md={4}>
                  <Panel
                    disabled={
                      surveyLocales.length === 0 ||
                      !survey.canUseBase(isAdmin())
                    }
                    classes={classes}
                    onClick={
                      surveyLocales.length > 0 && survey.canUseBase(isAdmin())
                        ? this.props.clickBasicSurveyCard
                        : undefined
                    }
                    label="基本設問文言設定"
                    image={
                      surveyLocales.length > 0 && survey.canUseBase(isAdmin())
                        ? BaseImg
                        : BaseDImg
                    }
                  />
                </Grid>
              )}

              <Grid item xs={12} md={4}>
                <Panel
                  disabled={
                    surveyLocales.length === 0 ||
                    !survey.canUseAdditions(isAdmin())
                  }
                  classes={classes}
                  onClick={
                    surveyLocales.length > 0 &&
                    survey.canUseAdditions(isAdmin())
                      ? this.props.clickAdditionalSurveyCard
                      : undefined
                  }
                  label="追加設問設定"
                  image={
                    surveyLocales.length > 0 &&
                    survey.canUseAdditions(isAdmin())
                      ? AdditionImg
                      : AdditionDImg
                  }
                />
              </Grid>
            </Grid>
          </div>

          <div className={classes.paperHeader}>管理</div>
          <div
            className={classnames(
              classes.paperContent,
              classes.adminPaperContent
            )}
          >
            <Grid container spacing={24}>
              <Grid item xs={12} md={4}>
                <Panel
                  classes={classes}
                  disabled={surveyLocales.length === 0}
                  onClick={
                    surveyLocales.length > 0
                      ? this.props.clickCheckPreviewCard(survey.id)
                      : undefined
                  }
                  label="チェック/プレビュー"
                  image={surveyLocales.length > 0 ? PreviewImg : PreviewDImg}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Panel
                  disabled={
                    surveyLocales.length === 0 || !survey.canUseMonitor()
                  }
                  classes={classes}
                  onClick={
                    surveyLocales.length > 0 && survey.canUseMonitor()
                      ? this.props.clickMonitoringCard
                      : undefined
                  }
                  label="モニタリング"
                  image={
                    surveyLocales.length > 0 && survey.canUseMonitor()
                      ? MonitorImg
                      : MonitorDImg
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Panel
                  disabled={!survey.canViewReport}
                  classes={classes}
                  onClick={
                    survey.canViewReport
                      ? this.props.clickReportCard
                      : undefined}
                  label="レポート"
                  image={survey.canViewReport ? ReportImg : ReportDImg}
                />
              </Grid>
            </Grid>
            {!isAdmin() && !survey.isFinish() && (
              <div className={classes.confirmMessage}>
                【ご注意】アンケートを作成したら必ずチェック/プレビューの「プレビュー」で、入力した情報が反映されているか内容をご確認ください。<br />
                「プレビュー」画面が実際の調査画面となります。
              </div>
            )}
          </div>
        </div>
      </Paper>
    );
  }
}
export default withStyles(styles)(SurveyDetail);



// WEBPACK FOOTER //
// ./src/components/SurveyDetail/index.jsx